import { connect } from 'react-redux';
import { PageSection, PageSectionHeader } from 'components/page';
import {
  AnalyticsCompetencies,
  AnalyticsOverviewContent,
  AnalyticsOverviewLogins,
  AnalyticsOverviewUsers
} from '.';

const AnalyticsOverview = connect((state) => ({
  messages: state.messages
}))(({ messages }) => (
  <div className="overview">
    <PageSection>
      <PageSectionHeader
        description={messages.analyticsUserStatisticsDescription}
        title={messages.analyticsUserStatistics}
      />

      <div className="users">
        <div className="row-md">
          <div className="col-1of4">
            <AnalyticsOverviewUsers />
          </div>
          <div className="col">
            <AnalyticsOverviewLogins />
          </div>
        </div>
      </div>
    </PageSection>

    <PageSection>
      <PageSectionHeader
        description={messages.analyticsCompetenciesAndAmbitionsDescription}
        title={messages.analyticsCompetenciesAndAmbitions}
      />

      <AnalyticsCompetencies />
    </PageSection>

    <PageSection>
      <PageSectionHeader
        description={messages.analyticsContentDescription}
        title={messages.analyticsContent}
      />

      <AnalyticsOverviewContent />
    </PageSection>
  </div>
));

export default AnalyticsOverview;
